import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { optimizationApi, type Recommendation } from '../../api/optimization';

export function RecommendationCenterPage() {
  const [recs, setRecs] = useState<Recommendation[]>([]);
  const [result, setResult] = useState<string | null>(null);
  useEffect(() => { void optimizationApi.recommendations().then(setRecs); }, []);
  const execute = async (id: string) => {
    const job = await optimizationApi.execute({ recommendation_id: id });
    setResult(`Executed: ${job.name} (${job.status})`);
  };
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Recommendation Center</h1>
      <Link to="/optimization" className="mt-2 inline-block text-sm text-violet-700 hover:underline dark:text-violet-400">← Optimization Center</Link>
      {result && <p className="mt-4 text-sm text-violet-700 dark:text-violet-400">{result}</p>}
      <div className="mt-6 space-y-3">{recs.map((r) => (
        <div key={r.id} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
          <div className="flex justify-between"><span className="font-medium">{r.title}</span><button type="button" onClick={() => execute(r.id)} className="text-sm text-violet-700 hover:underline dark:text-violet-400">Execute</button></div>
          <p className="mt-1 text-sm text-slate-500">{r.description}</p>
          <p className="mt-1 text-xs text-slate-500">{r.module} · Impact {r.impact_score} · Confidence {(r.confidence * 100).toFixed(0)}% · Savings ${r.savings_usd ?? 0}</p>
        </div>
      ))}</div>
    </div>
  );
}
